'use client'

import React, { FC, ReactElement, useMemo } from 'react'
import styles from './WalletHistory.module.css'
import Loading from '@/components/circle-loading'
import GradientText from '@/components/gradient-text'
import classNames from 'classnames'

import WalletHistoryItem from '../wallet-history-item'
import useWalletHistory from '@/utils/hooks/useWalletHistory'

const WalletHistory: FC<{ address?: string }> = (props): ReactElement => {
	const { address } = props
	const { data, isLoading } = useWalletHistory(address)

	const renderItem = React.useCallback(
		(e: any) => <WalletHistoryItem data={e} key={e.txid} address={address} />,
		[address]
	)

	const emptyText = useMemo(() => {
		if (address) {
			return `This address doesn't have a wallet history to display`
		} else {
			return 'You don’t have any wallet history to display'
		}
	}, [address])

	if (isLoading) {
		return (
			<div className={styles.loading}>
				<Loading />
			</div>
		)
	}

	return (
		<div className={styles.root}>
			{data?.length > 0 ? (
				data.map(renderItem)
			) : (
				<div className={styles.emptyContainer}>
					<GradientText classNames={classNames(styles.emptyTitle, 'display-lg', 'semibold')}>
						Wot?
					</GradientText>
					<p className={classNames(styles.emptyText, 'text-lg', 'regular')}>{emptyText}</p>
				</div>
			)}
		</div>
	)
}

export default WalletHistory
